import React, { useState, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { useAppContext } from "../libs/contextLib";
import { useHistory } from "react-router-dom";
import { s3GetWithBucket } from "../libs/awsLib";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import LoaderButton from "../components/LoaderButton";
import { useLoader } from '../context/LoaderContext';
import classificationsDisplayMap from "../constants/classificationsDisplayMap";
import "./Stamps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Stamps() {
    const { isAuthenticated, business } = useAppContext();
    const [ downloaded, hasDownloaded ] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [,setLoading] = useLoader();
    const history = useHistory();

    useEffect(() => {
        //ensures window scrolls to top when loading this page
        window.scrollTo(0, 0);
        
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }
            setIsLoading(false);
        }
  
        onLoad();
    }, [isAuthenticated]);

    useEffect(() => {
        setLoading(isLoading);
    }, [setLoading, isLoading]);

    async function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        history.push("socialcontent");
    }

    const downloadStamps = async () => {

        try {
            //Determine the classifications business has access to
            
            if (business && business.classifications && business.classifications.length > 0) {
                
                //Always give Small Business stamps as a part of download
                var hasSmallBusiness = business.classifications.includes('Small Business');
                if (!hasSmallBusiness) {
                    business.classifications.push("Small Business");
                }
                
                business.classifications.forEach(async (classification) => {
                    //get Classification and determine stamp image
                    var stampsBucket = classificationsDisplayMap[classification].zipFileS3Bucket;
                    var stampsFileName = classificationsDisplayMap[classification].zipFileName;

                    //Download image blob using s3 link
                    //stamps zip files are in a different bucket
                    const s3Url = await s3GetWithBucket(stampsBucket + stampsFileName, "sert-consumer");
                    let blob = await fetch(s3Url).then(r => r.blob());
                    if (blob) {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = classificationsDisplayMap[classification].zipFileName;
                        link.click();
                    }
                    hasDownloaded(true);
                });
        
            }
        } catch (e) {
            //TODO: show error modal
            console.log("*****image not found: ");
        }
    }
 
    return (
        <div className="stamps">
            {isAuthenticated && (
                <div className="content">
                    <div className="contentHeader row-bottom-20">
                        <div>
                            <h2>2. Download Sertify Stamps</h2>
                            <h4>Easily add Sertify Stamps yourself or forward them to your marketer. They are sized and ready to upload to your digital assets.</h4>
                        </div>
                    </div>
                    <div className="contentBody">
                        <ul>
                            <li>Your Website</li>
                            <li>Email Campaigns</li>
                            <li>Facebook Photo Gallery</li>
                            <li>Instagram Photo Gallery</li>
                            <li>Google Photo Gallery</li>
                            <li>Yelp Photo Gallery</li>
                            <li>Twitter Post</li>
                        </ul>
                    </div>
                    <div className="contentBody">
                        <div className="downloadStamps">
                            <div onClick={event => downloadStamps()} rel="noopener noreferrer" download title="Download Sertify images">
                                <FontAwesomeIcon icon={['fas', 'cloud-download-alt']} size="4x"></FontAwesomeIcon>
                            </div>
                            <div>
                                <span>&nbsp;
                                { !downloaded && (
                                    <>Download</>
                                )}
                                { downloaded && (
                                    <>Download complete &nbsp;<FontAwesomeIcon icon={['fas', 'check']} ></FontAwesomeIcon></>
                                )}
                                </span>
                            </div>
                        </div>
                    </div>
                    { /*
                    <div className="contentBody">
                        <div className="stamps"> 
                            <div className="left-text row-bottom-20">
                                <strong>3b. Add Sertify images to your website</strong>
                            </div>
                            <div className="contentSocial-container">
                                <div className="contentSocial row-bottom-20">
                                    <div className="contentSocial-logo">
                                        <FontAwesomeIcon icon={['fas', 'desktop']} size="3x"></FontAwesomeIcon>
                                    </div>
                                    <div className="contentSocial-child left-text">
                                        <span>Log-in to your website</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    */} 
                    { //show Back/Next buttons if user is going through onboarding for first time
                        !business.onboardingCompletionDate && (
                        <div className="pageButtons-multiple row-top-10">
                            <LinkContainer key="back" to="/sticker">
                                <Button variant="secondary">BACK</Button>
                            </LinkContainer>
                            <Form onSubmit={handleSubmit}>
                                <LoaderButton
                                    key="next"
                                    type="submit"
                                    variant="primary"
                                    value='next'
                                    isLoading={isLoading}       
                                >NEXT
                                </LoaderButton>
                            </Form>
                        </div>
                    )}
                    {   /* User has completed onboarding.  Show "DONE" button instead of "Next" */
                        business.onboardingCompletionDate && (
                        <div className="pageButtons-single row-top-10">
                            <LinkContainer key="nextHome" to="/home">
                                <Button variant="primary">DONE</Button>
                            </LinkContainer>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}